"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dialog = _interopRequireDefault(require("./Dialog.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Dialog = function Dialog(_ref) {
  var children = _ref.children,
    actions = _ref.actions,
    leftActions = _ref.leftActions,
    rightActions = _ref.rightActions,
    width = _ref.width,
    className = _ref.className,
    wrapperClassName = _ref.wrapperClassName,
    innerWidth = _ref.innerWidth,
    dataTestId = _ref.dataTestId,
    onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    width: width,
    innerWidth: innerWidth,
    className: wrapperClassName,
    onClick: onClose,
    "data-testid": dataTestId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    tabIndex: "0",
    "aria-hidden": "true",
    className: "dialog-inner ".concat(className),
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "dialog-message"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dialog-actions-container"
  }, leftActions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "dialog-actions-left"
  }, leftActions), actions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "dialog-actions-center"
  }, actions), rightActions && /*#__PURE__*/_react["default"].createElement("div", {
    className: "dialog-actions-right"
  }, rightActions))));
};
Dialog.defaultProps = {
  actions: undefined,
  leftActions: undefined,
  rightActions: undefined,
  width: '850px',
  className: '',
  wrapperClassName: undefined,
  innerWidth: undefined,
  dataTestId: 'dialog-wrapper',
  onClose: function onClose() {
    return null;
  }
};
Dialog.propTypes = {
  children: _propTypes["default"].node.isRequired,
  actions: _propTypes["default"].node,
  leftActions: _propTypes["default"].node,
  rightActions: _propTypes["default"].node,
  width: _propTypes["default"].string,
  className: _propTypes["default"].string,
  wrapperClassName: _propTypes["default"].string,
  innerWidth: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  onClose: _propTypes["default"].func
};
var _default = exports["default"] = Dialog;